import { React, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { toast } from "react-toastify";
import { Icon } from "@iconify/react";
import CloseOutlined from "@mui/icons-material/CloseOutlined";
import DialpadIcon from "@mui/icons-material/Dialpad";

import {
  Collapse,
  Fade,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Slide,
  Tooltip,
} from "@mui/material";

import "./Navbarbar.css";
import ConnectionStatus from "./ConnectionStatus";
import CallScheduleDialog from "../CallSchedule/CallScheduleDialog";
import AgentStatus from "../Chat/AgentStatus";
import BroadcastListDialog from "../Chat/BroadcastList/BroadcastListDialog";
import ChangePassModal from "../Chat/ChangePassModal";
import DialPad from "../Chat/DialPad";
import LegalNotesDialog from "../Chat/LegalNotesDialog";
import NotificationDialog from "../Chat/NotificationDialog";
import ChatbotListDialog from "../Chat/Chatbot/ChatbotListDialog";
import ReportingDialog from "../Chat/ReportingDialog";
import WhatsappTemplateDialog from "../Chat/WhatsappTemplate/WhatsappTemplateDialog";
import useWindowDimensions from "../Hooks/useWindowDimensions";
import LogoInApp from "../Images/LogoInApp.png";
import LogoMoxcal from "../Images/XOnly2.png";
import CreateSession from "../InAppCall/CreateSession";
import { setMakeCall } from "../Store/Actions/CallAction";
import { getListDashboard } from "../Store/Actions/DashboardAction";
import { getListReport } from "../Store/Actions/ReportAction";
import consoleLogger from "../Utils/logger";

export default function Navbarbar({
  handleLogout,
  changePage,
  myInfo,
  handleChange,
  changeColor,
  status,
  stateOptions,
  ChangeCompletePass,
}) {
  const [activeMenu, setActiveMenu] = useState("");
  const [anchorElSubMenu, setAnchorElSubMenu] = useState({});
  const [openModalPass, setOpenModalPass] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [reports, setReports] = useState([]);
  const [dashboards, setDashboards] = useState([]);
  const [isDialPadShown, setIsDialPadShown] = useState(false);
  const [isSettingsShown, setIsSettingsShown] = useState(false);
  const [isReportingDialogShown, setIsReportingDialogShown] = useState(false);
  const [isNotificationShown, setIsNotificationShown] = useState(false);
  const [isCallScheduleDialogShown, setIsCallScheduleDialogShown] =
    useState(false);

  const [isChatbotListDialogShown, setIsChatbotListDialogShown] =
    useState(false);

  const [isBroadcastListDialogShown, setIsBroadcastListDialogShown] =
    useState(false);

  const [isWhatsappTemplateDialogShown, setIsWhatsappTemplateDialogShown] =
    useState(false);

  const [avatarColor, setAvatarColor] = useState("");
  const [indicatorPosition, setIndicatorPosition] = useState(null);
  const [isLegalNotesDialogShown, setIsLegalNotesDialogShown] = useState(false);
  const [isReportsListShown, setIsReportsListShown] = useState(false);
  const [isChangePasswordAllowed, setIsChangePasswordAllowed] = useState(null);
  const [selectedReportURL, setSelectedReportURL] = useState("");
  const [selectedDashboardName, setSelectedDashboardName] = useState("");
  const [isSendingLogs, setIsSendingLogs] = useState(false);
  const [isCreateSessionShown, setIsCreateSessionShown] = useState(false);
  const dispatch = useDispatch();

  const { isInAutoDial, isAutoDialPaused } = useSelector(
    (state) => state.agent
  );

  const { accessMenu, agentPermission, CurrentState } = useSelector(
    (state) => state.auth
  );

  const { width } = useWindowDimensions();

  useEffect(() => {
    console.log("access menu: ", accessMenu);

    accessMenu.forEach((menu) => {
      if (menu.RowAttribute === "parentMenu") {
        setAnchorElSubMenu({
          ...anchorElSubMenu,
          [menu.DisplayText]: null,
        });
      }
    });
  }, [accessMenu]);

  useEffect(() => {
    const changePasswordPermission = agentPermission.find(
      (permission) => permission.PermissionCode === "User.ChangePassword"
    );

    if (
      changePasswordPermission &&
      changePasswordPermission.PermissionAccess === "A"
    ) {
      setIsChangePasswordAllowed(true);
    } else {
      setIsChangePasswordAllowed(false);
    }
  }, [agentPermission]);

  useEffect(() => {
    getListReport(myInfo.user.AgentCode)
      .then((response) => {
        if (response.status) {
          process.env.NODE_ENV === "development" &&
            console.log("Report items: ", response.data);

          setReports(response.data);
        } else {
          console.log("error", response.error);
        }
      })
      .catch((err) => console.log("err", err));

    getListDashboard(myInfo.user.AgentCode)
      .then((response) => {
        if (response.status) {
          setDashboards(response.data);
        } else {
          console.log("error", response.error);
        }
      })
      .catch((err) => console.log("err", err));
  }, []);

  const handleClose = () => {
    setAnchorElSubMenu({});
  };

  const renderDialpadButton = () => {
    const manualDialPermission = agentPermission.find(
      (permission) => permission.PermissionCode === "Call.ManualDial"
    );

    if (manualDialPermission && manualDialPermission.PermissionAccess === "A") {
      return (
        <IconButton
          size="large"
          className={`MyCustomButton dialpad-button ${
            isDialPadShown ? "open" : ""
          }`}
          onClick={() => setIsDialPadShown(!isDialPadShown)}
        >
          <li>{isDialPadShown ? <CloseOutlined /> : <DialpadIcon />}</li>
        </IconButton>
      );
    } else {
      return null;
    }
  };

  const handleUserInitials = () => {
    const username = myInfo.user.AgentName;

    if (username.includes(" ")) {
      // If username has space, show the first name and last name initials
      const split = username.split(" ");
      return (split[0].charAt(0) + split.at(-1).charAt(0)).toUpperCase();
    } else {
      // Else, show first two letters
      return username.slice(0, 2);
    }
  };

  const handleAvatarColor = () => {
    if (avatarColor === "") {
      const colors = [
        "#ba68c8",
        "#F97427",
        "#4caf50",
        "#ffe200",
        "#35aeac",
        "#13e1ce",
        "#2a51da",
        "#5f72f0",
        "#d1fe87",
        "#005c55",
        "#baa0b2",
        "#57cda3",
        "#a1a770",
        "#552336",
        "#3e7e4f",
        "#dfd7a8",
        "#66702d",
        "#edc1e2",
        "#329702",
        "#a15d8c",
        "#623453",
        "#a85142",
        "#506c0b",
        "#24119b",
        "#c0926f",
        "#6e26c3",
        "#dadd24",
        "#d94953",
        "#5f8fac",
        "#bcd7f3",
      ];

      let randomColor = colors[Math.floor(Math.random() * 30)];
      setAvatarColor(randomColor);
      return randomColor;
    } else {
      return avatarColor;
    }
  };

  const handleCall = () => {
    if (phoneNumber.length > 0) {
      dispatch(
        setMakeCall({
          phoneNo: phoneNumber.replace(/-/g, ""),
          agentStatus: CurrentState,
        })
      );

      setIsDialPadShown(false);
      setPhoneNumber("");
    }
  };

  function renderProductionText(displayText) {
    if (displayText === "Production") {
      if (
        !myInfo.user.AgentTSS ||
        myInfo.user.AgentTSS.TaskGroupCode === "AGENT"
      ) {
        return "Reconfirm";
      }
    }

    return displayText;
  }

  return (
    <div>
      <AgentStatus
        myInfo={myInfo}
        handleChange={handleChange}
        changeColor={changeColor}
        status={status}
        stateOptions={stateOptions}
        changePage={changePage}
      />

      <div className="Navbarbar">
        {
          /* To limit user interaction during auto dial */
          isInAutoDial ||
            (isAutoDialPaused && <div className="auto-dial-overlay" />)
        }

        <NavLink to="/" onClick={() => changePage()}>
          <img
            src={width < 1200 ? LogoInApp : LogoMoxcal}
            alt=""
            className="LogoTopCorner"
          />
        </NavLink>

        <nav>
          {
            // Get menus
            accessMenu
              ?.filter((menu) => !menu.ParentMenu && menu.Icon)
              .map((menu) =>
                //Remove QA menu for mobile
                width <= 780 ? (
                  menu.DisplayText === "Quality Assurance" ? null : (
                    <Tooltip title={menu.DisplayText} arrow placement="right">
                      <IconButton
                        size="large"
                        className={`MyCustomButton ${
                          activeMenu === menu.DisplayText ? "active" : ""
                        }`}
                        onClick={(event) => {
                          setActiveMenu(menu.DisplayText);
                          setIndicatorPosition(60 * (menu.Position - 1));

                          menu.Link
                            ? changePage(menu.Link)
                            : setAnchorElSubMenu({
                                ...anchorElSubMenu,
                                [menu.DisplayText]: event.currentTarget,
                              });
                        }}
                      >
                        {activeMenu === menu.DisplayText && (
                          <span className="indicator" />
                        )}

                        <Icon className="icon" icon={menu.Icon} height="30" />
                      </IconButton>
                    </Tooltip>
                  )
                ) : (
                  <Tooltip
                    title={renderProductionText(menu.DisplayText)}
                    arrow
                    placement="right"
                  >
                    <IconButton
                      size="large"
                      className={`MyCustomButton ${
                        activeMenu === menu.DisplayText ? "active" : ""
                      }`}
                      onClick={(event) => {
                        setActiveMenu(menu.DisplayText);
                        setIndicatorPosition(60 * (menu.Position - 1));

                        menu.Link !== "NULL"
                          ? changePage(menu.Link)
                          : setAnchorElSubMenu({
                              ...anchorElSubMenu,
                              [menu.DisplayText]: event.currentTarget,
                            });
                      }}
                    >
                      {activeMenu === menu.DisplayText && (
                        <span className="indicator" />
                      )}

                      <Icon className="icon" icon={menu.Icon} height="30" />
                    </IconButton>
                  </Tooltip>
                )
              )
          }

          {
            // Get menus that have children
            accessMenu
              ?.filter((menu) => menu.RowAttribute === "parentMenu")
              .map((menu) => (
                <Menu
                  anchorEl={anchorElSubMenu[menu.DisplayText]}
                  open={Boolean(anchorElSubMenu[menu.DisplayText])}
                  onClose={handleClose}
                  onClick={handleClose}
                  transformOrigin={{ horizontal: "left", vertical: "top" }}
                  anchorOrigin={{ horizontal: "right", vertical: "top" }}
                >
                  {accessMenu
                    ?.filter((subMenu) => subMenu.ParentMenu === menu.MenuID)
                    .map((subMenu) => (
                      <MenuItem
                        onClick={() => {
                          setActiveMenu(menu.DisplayText);
                          setIndicatorPosition(60 * (menu.Position - 1));
                          changePage(subMenu.Link);
                        }}
                      >
                        <ListItemIcon>
                          <Icon
                            className="icon"
                            height="26"
                            icon={subMenu.Icon}
                          />
                        </ListItemIcon>

                        {subMenu.DisplayText}
                      </MenuItem>
                    ))}

                  {menu.DisplayText === "Dashboard" &&
                    dashboards.length > 0 && (
                      <>
                        <MenuItem disabled>Custom Dashboards</MenuItem>

                        {dashboards.map((dashboard) => (
                          <MenuItem
                            onClick={() => {
                              setSelectedDashboardName(
                                dashboard.dashboard_name
                              );

                              setSelectedReportURL(dashboard.access_url);
                              setIsReportingDialogShown(true);
                            }}
                          >
                            <ListItemIcon>
                              <Icon
                                className="icon"
                                height="26"
                                icon="material-symbols:dashboard-outline-rounded"
                              />
                            </ListItemIcon>

                            {dashboard.dashboard_name}
                          </MenuItem>
                        ))}
                      </>
                    )}
                </Menu>
              ))
          }

          {renderDialpadButton()}
        </nav>

        <ConnectionStatus />

        <div
          className="navbar-settings"
          onClick={() => {
            setIsSettingsShown((prevState) => !prevState);
          }}
        >
          <Icon
            className="icon"
            color="#0343C7"
            height="30"
            icon="icon-park-outline:more-four"
          />

          <div className="separator" />

          <div
            className="avatar"
            style={{ backgroundColor: handleAvatarColor() }}
          >
            {handleUserInitials()}
          </div>
        </div>

        {isDialPadShown && (
          <DialPad
            phoneNumber={phoneNumber}
            setPhoneNumber={setPhoneNumber}
            handleCall={handleCall}
          />
        )}

        <div className="settings-drawer-slide-container"></div>

        <Fade in={isSettingsShown} unmountOnExit>
          <div
            className="settings-overlay"
            onClick={() => setIsSettingsShown(false)}
          >
            <IconButton
              className="legal-notes-button"
              onClick={() => setIsLegalNotesDialogShown(true)}
            >
              <Icon height="22" icon="material-symbols:info-outline" />
            </IconButton>

            <p className="copyrights">
              Copyrights by PT.Moxcal Teknologi {new Date().getFullYear()}
            </p>
          </div>
        </Fade>

        <Slide appear direction="right" in={isSettingsShown} mountOnEnter>
          <div className="settings-drawer">
            <div className="container">
              <h1>More</h1>
            </div>

            <div className="settings-list">
              {accessMenu
                ?.filter((menu) => menu.RowAttribute === "moreMenu")
                .map((menu) => {
                  /*
                      Condition for active class check,
                      Action for onClick function
                    */
                  let condition, action;

                  switch (menu.DisplayText) {
                    case "Reports":
                      condition = isReportsListShown;
                      action = () => setIsReportsListShown(!isReportsListShown);
                      break;

                    case "Change Password":
                      condition = openModalPass;
                      action = () => setOpenModalPass(true);
                      break;

                    case "Notification":
                      condition = isNotificationShown;
                      action = () => setIsNotificationShown(true);
                      break;

                    case "Call Schedule":
                      condition = isCallScheduleDialogShown;
                      action = () => setIsCallScheduleDialogShown(true);
                      break;

                    case "Operator List":
                      condition = isChatbotListDialogShown;
                      action = () => setIsChatbotListDialogShown(true);
                      break;

                    case "Broadcast List":
                      condition = isBroadcastListDialogShown;
                      action = () => setIsBroadcastListDialogShown(true);
                      break;

                    case "Whatsapp Template":
                      condition = isWhatsappTemplateDialogShown;
                      action = () => setIsWhatsappTemplateDialogShown(true);
                      break;

                    case "Assign Team":
                      break;

                    case "In-app Call":
                      condition = isCreateSessionShown;
                      action = () => setIsCreateSessionShown(true);
                      break;

                    case "Send Logs":
                      condition = isWhatsappTemplateDialogShown;

                      action = () => {
                        setIsSendingLogs(true);

                        consoleLogger
                          .sendLogsToAPI()
                          .then((response) => {
                            if (response.success) {
                              toast.success("Logs sent successfully", {
                                autoClose: 3000,
                              });

                              setIsSendingLogs(false);
                            } else {
                              console.log("error", response.error);
                            }
                          })

                          .catch((err) =>
                            console.error("Failed to send error logs:", err)
                          );
                      };

                      break;

                    default:
                      break;
                  }

                  return (
                    <>
                      {
                        // Additional condition for change password permission
                        menu.DisplayText === "Change Password" &&
                        isChangePasswordAllowed === false ? null : (
                          <div
                            className={`settings-item ${
                              condition
                                ? "active"
                                : menu.DisplayText === "Reports"
                                ? "Reports"
                                : menu.DisplayText === "Send Logs"
                                ? "send-logs"
                                : ""
                            }`}
                            onClick={action}
                          >
                            <Icon
                              className="icon"
                              height="30"
                              icon={menu.Icon}
                            />

                            {menu.DisplayText}

                            {menu.DisplayText === "Send Logs" &&
                              isSendingLogs && (
                                <Icon
                                  className="icon"
                                  height="30"
                                  icon="eos-icons:loading"
                                />
                              )}
                          </div>
                        )
                      }

                      {
                        // Reports submenu
                        menu.DisplayText === "Reports" && (
                          <Collapse in={isReportsListShown} unmountOnExit>
                            <div className="reports-list">
                              {reports.map((report) => (
                                <div
                                  className="reports-list-item"
                                  onClick={() => {
                                    setSelectedReportURL(report.access_url);
                                    setIsReportingDialogShown(true);
                                  }}
                                >
                                  <Icon
                                    className="icon"
                                    height="30"
                                    icon="radix-icons:dot"
                                  />

                                  {report.report_name}
                                </div>
                              ))}
                            </div>
                          </Collapse>
                        )
                      }
                    </>
                  );
                })}
            </div>
            <footer>
              <div className="user-info">
                <p className="username">{myInfo.user.AgentName}</p>
                <p className="team">Team A</p>
              </div>

              <Tooltip title="Log out" arrow>
                <IconButton onClick={handleLogout}>
                  <Icon
                    className="icon"
                    height="30"
                    icon="mdi:logout-variant"
                  />
                </IconButton>
              </Tooltip>
            </footer>
          </div>
        </Slide>

        <ReportingDialog
          dashboardName={selectedDashboardName}
          isOpen={isReportingDialogShown}
          selectedURL={selectedReportURL}
          setIsReportingDialogShown={setIsReportingDialogShown}
          setSelectedDashboardName={setSelectedDashboardName}
        />

        <NotificationDialog
          isOpen={isNotificationShown}
          setIsNotificationDialogShown={setIsNotificationShown}
        />

        <CallScheduleDialog
          changePage={changePage}
          isOpen={isCallScheduleDialogShown}
          setIsOpen={setIsCallScheduleDialogShown}
          setIsSettingsShown={setIsSettingsShown}
        />

        <ChatbotListDialog
          isOpen={isChatbotListDialogShown}
          setIsChatbotListDialogShown={setIsChatbotListDialogShown}
        />

        <BroadcastListDialog
          isOpen={isBroadcastListDialogShown}
          setIsBroadcastListDialogShown={setIsBroadcastListDialogShown}
        />

        <WhatsappTemplateDialog
          isOpen={isWhatsappTemplateDialogShown}
          setIsWhatsappTemplateDialogShown={setIsWhatsappTemplateDialogShown}
        />

        <LegalNotesDialog
          isOpen={isLegalNotesDialogShown}
          setIsLegalNotesDialogShown={setIsLegalNotesDialogShown}
        />

        <CreateSession
          isOpen={isCreateSessionShown}
          setIsCreateSessionShown={setIsCreateSessionShown}
        />
      </div>

      {openModalPass ? (
        <ChangePassModal
          ChangeCompletePass={ChangeCompletePass}
          onClose={() => setOpenModalPass(false)}
        />
      ) : (
        ""
      )}
    </div>
  );
}
